import { FlagsComponentRouter, FlagsSingleton } from 'flags'

import {
  isFamilyResourcesPageInProgramFlex,
  isHighSchoolUrl,
  isDigitalWellBeingUrl,
  isMiddleSchoolPage,
  isElementaryPage,
} from 'utils/productHelpers'

import OffComponent from './flag.off/index'
import OnComponent from './flag.on/index'

// TODO: Remove this flag once the program flex is fully deployed for all pages that use subnav.
// Right now its known that is the kit pages but could be others
const FlagToggler = FlagsComponentRouter({
  flagSubscriptions: ['refactor_LEARN-18413-pages-component-program-flex'],
  OnComponent,
  OffComponent,
  flagsChecker: FlagsSingleton.checkAtLeastOneFlagTrue,
  onCondition: () => {
    return (
      isFamilyResourcesPageInProgramFlex() ||
      isHighSchoolUrl() ||
      isDigitalWellBeingUrl() ||
      isMiddleSchoolPage() ||
      isElementaryPage()
    )
  },
})

export default FlagToggler
